import React from 'react';
import { ActiveMarker } from '../../icons';

/**
 * Single active mission with deliverables progress.
 */
const ActiveMissionItem = ({ task, onGoToTask, onMouseEnter, onMouseLeave }) => {
  const deliverables = task.deliverables || [];
  const completedDeliverables = deliverables.filter((d) => d.completed).length;
  const totalDeliverables = deliverables.length;
  const hasDeliverables = totalDeliverables > 0;

  return (
    <div
      className="flowchart-hud__mission-item flowchart-hud__mission-item--active"
      onClick={() => onGoToTask?.(task.id)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span className="flowchart-hud__mission-marker">
        <ActiveMarker size={16} className="flowchart-hud__active-icon--small" />
      </span>
      <div className="flowchart-hud__mission-content">
        <span className="flowchart-hud__mission-name">
          {task.name}
          {hasDeliverables && (
            <span className={`flowchart-hud__mission-progress ${completedDeliverables === totalDeliverables ? 'flowchart-hud__mission-progress--complete' : ''}`}>
              {completedDeliverables}/{totalDeliverables}
            </span>
          )}
        </span>
        {hasDeliverables && (
          <div className="flowchart-hud__mission-deliverables">
            {deliverables.map((del, idx) => (
              <span
                key={del.id || idx}
                className={`flowchart-hud__deliverable-item ${del.completed ? 'flowchart-hud__deliverable-item--done' : ''}`}
                title={del.name}
              >
                {del.completed ? '✓' : '○'} {del.name}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveMissionItem;
